

import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { fetchData, postData, putData, updateData, deleteData, activateData } from '../../../apiService'; // Assuming putData is used for updating
import { Card, CardContent, TableContainer, Paper, Tooltip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, ListItem } from '@mui/material';
import Select from 'react-select';
import DeleteIcon from '@mui/icons-material/Delete';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Link } from 'react-router-dom';
import BlockIcon from '@mui/icons-material/Block';
import { TextField } from '@mui/material';
import { Discount } from '@mui/icons-material';
import UndoIcon from '@mui/icons-material/Undo';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import SyncIcon from '@mui/icons-material/Sync';
import EditIcon from '@material-ui/icons/Edit';
const SaleDetails = () => {
    const { id } = useParams();
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [customerId, setCustomerId] = useState('');
    const [loading, setLoading] = useState(false);
    const [categoryId, setCategoryId] = useState('');
    const [productCategoryId, setPCategoryId] = useState('');
    const [itemList, setItemList] = useState([]);
    const [itemnameget, setItemName] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [formData, setFormData] = useState([]);
    const [itemdata, setData] = useState([]);
    const [tid, setTripId] = useState("");
    const [prefix, setprefix] = useState('');
    const [SaleorderId, setSaleorderId] = useState('');




    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();

    // State to control the visibility of the container
    const [isContainerVisible, setIsContainerVisible] = useState(false);

    const toggleContainerVisibility = () => setIsContainerVisible(!isContainerVisible);


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        fetchItemData();
    }, [isAuthenticated, companyId, token, logout]);
    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        let month = (date.getMonth() + 1).toString();
        let day = date.getDate().toString();

        // Pad the month and day with leading zeros if needed
        month = month.length === 1 ? `0${month}` : month;
        day = day.length === 1 ? `0${day}` : day;

        return `${year}-${month}-${day}`;
    };
    const formatTimeForInput = (timeString) => {
        const time = new Date(`1970-01-01T${timeString}`);
        const hours = time.getHours().toString().padStart(2, '0');
        const minutes = time.getMinutes().toString().padStart(2, '0');
        const seconds = time.getSeconds().toString().padStart(2, '0');

        return `${hours}:${minutes}:${seconds}`;
    };

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    //Sale Details
    useEffect(() => {
        fetchData('SaleApi', `/LedgerSaleDetails/${id}`, token)
            //fetchData('AdditonalReportAPi', `/SaleDetails/${id}`, token)
            .then((response) => {
                const array = response.response_data.saleDetails;
                setLoading(true);
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.sale);
                    setSaleorderId(response.response_data.sale.saleOrderId);
                    setData(response.response_data.saleDetails);

                }
                setFormData((prevData) => ({
                    ...prevData,
                    ModifiedBy: userId,
                }));
                console.log(response.response_data.SaleDetails);
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [id]);


    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const fetchItemData = async () => {
        try {
            setLoading(true);
            const response = await fetchData('SaleApi', `/LedgerSaleDetails/${id}`, token);
            if (response.responseCode === '1111') {
                setFormData(response.response_data.sale); //TripId
                setSaleorderId(response.response_data.sale.saleOrderId);
                setCustomerId(response.response_data.sale.CustomerId);
                setData(response.response_data.saleDetails);
                setItemList(response.response_data.saleDetails);
                setTripId(response.response_data.sale.TripId);
                console.log(tid);
            }
            setIsModalOpen(true);
        } catch (error) {
            console.error('Error fetching Item', error);
        }
        finally {
            setLoading(false);
        }
    };


    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [itemName, setItemNames] = useState('');





    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);
        setDeleteItemId(null);
        setItemNames('');
    };


    const Saleprefix =
        formData.taxMethod === 1 ? 'BB' :
            formData.taxMethod === 2 ? 'C' :
                formData.taxMethod === 3 ? 'E' : '';

    return (
        <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ maxHeight: '730px', overflow: 'auto', maxWidth: '98%' }}>
            {loading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999
                }}>
                    <div>
                        <CircularProgress style={{ color: 'white' }} />
                        <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                    </div>
                </div>
            )}
            <style>
                {`
                      .container::-webkit-scrollbar {
                        width: 0.1em;
                      }
                      .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                      }
                      .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                      }
                    `}
            </style>
            <div className="bg-tabcolor rounded-lg shadow-lg p-6" style={{ maxWidth: '100%', backgroundColor: 'rgba(255, 255, 255, 0.5)', maxHeight: '2000px', overflowY: 'auto' }}>
                <div className="bg-tabcolor rounded-lg shadow-lg p-6" style={{ marginLeft: '-5px', marginTop: '-20px', backgroundColor: 'rgba(255, 255, 255, 0.5)', overflowY: 'auto' }}>
                    <h5 className="block uppercase text-lg font-semibold mb-4 linkcolor mr-2" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'brown', textAlign: 'left', marginTop: '-15px' }}>SALE DETAILS</h5>

                    <h4 className="flex-grow  font-serif" style={{ marginLeft: '45%', marginTop: '-50px', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', fontSize: '18px', color: '#A25772' }}>
                        Route :{' '}
                        {formData.route}
                    </h4>
                    <div className="flex mb-2" style={{ marginTop: '20px' }}>
                        <h6 className="flex-grow" style={{ fontSize: '16px', color: '#45273A', fontWeight: 'bold' }}>
                            Invoice No: {Saleprefix}{formData.invoiceNo}/{formData.finYear} </h6>
                        <h6 className="flex-grow" style={{ marginLeft: '-140px', fontSize: '16px', color: '#1E2A5E' }}>
                            Sale Date: {''}
                            {formatDateForInput(formData.invoiceDate)}
                        </h6>
                        <h6 className="flex-grow" style={{ marginLeft: '-150px', fontSize: '16px', color: '#B8001F' }}>
                            Customer :{' '}
                            {formData.customerName}
                        </h6>
                    </div>

                    <div className="flex mb-2" style={{ justifyContent: "flex-end", marginTop: '-45px' }}>
                        <Tooltip title="Sale Edit">
                            <Link to={`/RouteClosingSaleOrderEdit/${SaleorderId}`}>
                                <Button style={{ background: '#FFA62F', color: 'white', fontWeight: '600', marginLeft: '100px', fontSize: '12px', height: '30px' }}>
                                    Sale Edit <EditIcon />
                                </Button>
                            </Link>
                        </Tooltip>
                        <Tooltip title="Back To List">
                            <Link to="/Ledger" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                <Button variant="contained" color="error" style={{ marginLeft: '10px', height: '30px' }}>
                                    Back <ExitToAppIcon />
                                </Button>
                            </Link>
                        </Tooltip>
                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <br />
                    <div className="w-full mb-4 flex">
                        <TableContainer component={Paper}>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="px-4 py-2 text-left text-sm font-medium" style={{ width: '16%', fontSize: '14px' }}>Name</th>
                                        <th className="px-4 py-2 text-right text-sm font-medium" style={{ fontSize: '14px' }}>Qty
                                            <p style={{ fontSize: '10px', marginBottom: '-10px' }}>(No.Pieces)</p>
                                        </th>
                                        <th className="px-4 py-2 text-right text-sm font-medium" style={{ textAlign: 'left', width: '12%', fontSize: '14px' }}>Total Qty
                                            <p style={{ fontSize: '11px', marginBottom: '-10px' }}>(Kgs)</p>
                                        </th>
                                        <th className="px-4 py-2 text-right text-sm font-medium" style={{ textAlign: 'center', width: '2%', fontSize: '14px' }}>Bundle</th>
                                        <th className="px-4 py-2 text-right text-sm font-medium" style={{ textAlign: 'center', width: '2%', fontSize: '14px' }}>Pieces</th>
                                        <th className="px-4 py-2 text-right text-sm font-medium" style={{ width: '12%', fontSize: '14px' }}>Rate/Kg
                                            <p style={{ fontSize: '10px', marginBottom: '-10px' }}>(Including Tax)</p>
                                        </th>
                                        <th className="px-4 py-2 text-right text-sm font-medium" style={{ width: '3%', fontSize: '14px' }}>Discount</th>
                                        <th className="px-4 py-2 text-right text-sm font-medium" style={{ textAlign: 'center', width: '14%', fontSize: '14px' }}>Rate
                                            <p style={{ fontSize: '9.5px', marginBottom: '-10px' }}>(After Discount)</p>
                                        </th>
                                        <th className="px-4 py-2 text-right text-sm font-medium" style={{ width: '12%', textAlign: 'left', fontSize: '14px' }}>Taxable Amt </th>
                                        {/* <span style={{ fontSize: '12px' }}>Amt</span> */}
                                        <th className="px-4 py-2 text-right text-sm font-medium" style={{ width: '3%', textAlign: 'left', fontSize: '14px' }}>GST%</th>
                                        <th className="px-4 py-2 text-right text-sm font-medium" style={{ width: '13%', fontSize: '14px' }}>
                                            GST(₹)
                                        </th>
                                        <th className="px-4 py-2 text-right text-sm font-medium" style={{ width: '10%', fontSize: '14px' }}>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {itemList.map((invdetail, index) => (
                                        <tr key={index} className={invdetail.ColorCode === '#ffffff' ? 'white-row' : ''} style={{ width: '100%' }}>

                                            <td className="px-4 py-2 border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '15%', color: 'blueviolet' }}>{invdetail.itemName}</td>
                                            <td className="px-4 py-2 border-r text-right text-sm" style={{ padding: '1px', fontSize: '14px', width: '7%', textAlign: 'center', backgroundColor: invdetail.quantity > invdetail.BalStock ? '#ffcccc' : 'inherit' }}>
                                                {invdetail.quantity}
                                            </td>
                                            <td className="px-4 py-2 border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '11%' }}>{invdetail.totalQty}</td>
                                            <td className="px-4 py-2 border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '5%' }}>{invdetail.bundle}</td>
                                            <td className="px-4 py-2 border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '5%' }}>{invdetail.pieces}</td>
                                            <td className="px-4 py-2 border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '13%' }}> {invdetail.ratePerKg ? invdetail.ratePerKg.toFixed(2) : '0.00'}</td>
                                            <td className="px-4 py-2 border-r text-right text-sm" style={{ width: '10%' }}>
                                                {(isNaN(invdetail.discountPerPiece) || invdetail.discountPerPiece === "") ? '0' : invdetail.discountPerPiece}
                                            </td>
                                            <td className="px-4 py-2 border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '12%' }}>
                                                {(invdetail.rateAfterDiscount).toFixed(2)}
                                            </td>
                                            <td className="px-4 py-2 border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '7%', textAlign: 'right' }}>{invdetail.taxableAmt ? invdetail.taxableAmt.toFixed(2) : '0.00'}</td>
                                            <td className="px-4 py-2 border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '45%' }}>{invdetail.gstRate}</td>
                                            <td className="px-4 py-2 border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '9%', textAlign: 'right' }}>{invdetail.gstAmt ? invdetail.gstAmt.toFixed(2) : '0.00'}</td>
                                            <td className="px-4 py-2 border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '9%', textAlign: 'right' }}> {invdetail.netAmount ? invdetail.netAmount.toFixed(2) : '0.00'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot style={{ backgroundColor: 'lightblue' }}>
                                    <tr>
                                        <td className="border-r text-left text-sm" colSpan="1">TOTAL</td>

                                        {/* Total quantity */}
                                        <td className="border-r text-center text-sm">
                                            {itemList.reduce((acc, item) => acc + (item.quantity || 0), 0)}
                                        </td>

                                        {/* Total totalQty */}
                                        <td className="border-r text-right text-sm">
                                            {itemList.reduce((acc, item) => acc + (item.totalQty || 0), 0)}
                                        </td>

                                        {/* Total bundles */}
                                        <td className="border-r text-right text-sm">
                                            {itemList.reduce((acc, item) => acc + (item.bundle || 0), 0)}
                                        </td>

                                        {/* Total pieces */}
                                        <td className="border-r text-right text-sm">
                                            {itemList.reduce((acc, item) => acc + (item.pieces || 0), 0)}
                                        </td>

                                        {/* Total RatePerKg */}
                                        <td className="border-r text-right text-sm" style={{ backgroundColor: '#D1E9F6', color: 'brown', fontWeight: 'bold' }}>
                                            {itemList.reduce((acc, item) => acc + (Number(item.ratePerKg) || 0), 0).toFixed(2)}
                                        </td>

                                        {/* Total DiscountPerPiece */}
                                        <td className="border-r text-right text-sm">
                                            {itemList.reduce((acc, item) => acc + (Number(item.discountPerPiece) || 0), 0).toFixed(2)}
                                        </td>

                                        {/* Total Rate After Discount */}
                                        <td className="border-r text-right text-sm" style={{ backgroundColor: '#F1D3CE', color: 'brown', fontWeight: 'bold' }}>
                                            {itemList.reduce((acc, item) => {
                                                const ratePerKg = Number(item.ratePerKg) || 0;
                                                const discountPerPiece = Number(item.discountPerPiece) || 0;
                                                return acc + (ratePerKg - discountPerPiece);
                                            }, 0).toFixed(2)}
                                        </td>

                                        {/* Total Taxable Amount */}
                                        <td className="border-r text-right text-sm" style={{ backgroundColor: '#DCFFB7', color: 'brown', fontWeight: 'bold' }}>
                                            {itemList.reduce((acc, item) => acc + (Number(item.taxableAmt) || 0), 0).toFixed(2)}
                                        </td>

                                        {/* Total GST Rate */}
                                        <td className="border-r text-right text-sm">
                                            {itemList.reduce((acc, item) => acc + (Number(item.gstRate) || 0), 0).toFixed(2)}
                                        </td>

                                        {/* Total GST Amount */}
                                        <td className="border-r text-right text-sm">
                                            {itemList.reduce((acc, item) => acc + (Number(item.gstAmt) || 0), 0).toFixed(2)}
                                        </td>

                                        {/* Total Amount */}
                                        <td className="border-r text-right text-sm" style={{ backgroundColor: '#C7FFD8', color: 'brown', fontWeight: 'bold' }}>
                                            {itemList.reduce((acc, item) => acc + (Number(item.totalAmount) || 0), 0).toFixed(2)}
                                        </td>
                                    </tr>
                                </tfoot>

                            </table>
                            {/* <Dialog
                                open={confirmDialogOpen}
                                onClose={closeConfirmDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        ⚠️ Are you sure you want to delete  "{itemnameget}" permanently?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <button
                                        onClick={closeConfirmDialog}
                                        style={{
                                            backgroundColor: '#dc3545',
                                            color: '#ffffff',
                                            border: '1px solid #dc3545',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                            marginRight: '8px',
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleDelete}
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: '#ffffff',
                                            border: '1px solid #28a745',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Confirm
                                    </button>
                                </DialogActions>
                            </Dialog> */}
                        </TableContainer>
                    </div>
                </div>
            </div>


        </div >


    );
};

export default SaleDetails;
